export default __webpack_public_path__ + "static/media/logo.b250e977.svg";